import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/orders/page', data, {
    trim: true
  })
}
export function commentList (data) {
  return request.post('/business/orders/commentList', data, {
    trim: true
  })
}
// 导出Excel
export function exportExcel (data) {
  return request.post('/business/orders/exportExcel', data, {
    download: true,
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/orders/create', data)
}
export function cancel (id) {
  return request.get(`/business/orders/cancel?id=${id}`)
}

// 修改
export function updateById (data) {
  return request.post('/business/orders/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/orders/delete/${id}`)
}
// 删除
export function getById (id) {
  return request.get(`/business/orders/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/orders/delete/batch', {
    params: {
      ids
    }
  })
}
